<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="mb-5">
      <PageTitle title="Criar banner" />
    </b-col>
    <b-col cols="12" class="form-group">
      <label class="font-weight-bold">
        Banner *
        <b-button
          v-if="fields.image"
          size="sm"
          variant="danger"
          class="ml-2"
          @click="removeImage()"
        >
          <i class="fas fa-trash"></i>
        </b-button>
      </label>
      <div v-if="fields.image">
        <b-img :src="`${getImagesAddress}${fields.image}`" fluid></b-img>
      </div>
      <b-form-file
        v-else
        accept="image/*"
        browse-text="Selecionar"
        placeholder="Insira uma imagem de 1920px de largura por 500px de altura"
        v-model="imageSelected"
        @input="addImage()"
      ></b-form-file>
      <error-message :errorMessage="requiredFields.image" />
    </b-col>
    <b-col cols="12" class="form-group">
      <label class="font-weight-bold">URL (Opcional)</label>
      <input
        type="text"
        class="form-control"
        id="video"
        v-model="fields.urlToRedirect"
        placeholder="Link para qual o usuário será redirecionado ao clicar no banner (Ex: https://youtube.com...)"
      />
    </b-col>
    <b-col cols="6" class="mb-2">
      <b-button variant="danger" class="btn-block" @click="redirect()">
        <i class="fas fa-arrow-left mr-2"></i>
        Voltar
      </b-button>
    </b-col>

    <b-col cols="6" class="mb-2">
      <b-button variant="success" class="btn-block" @click="save()">
        <i class="fas fa-save mr-2"></i>
        Salvar
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';

import makeToast from 'Mixins/makeToast';
import ErrorMessage from 'Components/ErrorMessage.vue';

export default {
  name: 'CustomizationSaveBanner',
  mixins: [makeToast],
  components: { PageTitle, ErrorMessage },
  data() {
    return {
      imageSelected: null,
      fields: {
        id: '',
        image: '',
        urlToRedirect: '',
      },
      requiredFields: {},
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddress']),
  },
  mounted() {
    const { id } = this.$route.params;
    this.fields.id = id || '';

    this.get();
  },
  methods: {
    ...mapActions('professional', ['saveBanner', 'getBanner']),
    ...mapActions('files', ['sendUploadFiles', 'deleteFile']),
    get() {
      if (!this.fields.id) return;

      this.$store.dispatch('startLoader');

      this.getBanner(this.fields.id)
        .then((response) => {
          const { image, urlToRedirect } = response.data.data;
          this.fields.image = image || '';
          this.fields.urlToRedirect = urlToRedirect || '';
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer o banner', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    redirect() {
      this.$router.push({ name: 'profissional-website-banner' });
    },
    save() {
      const request = {
        professionalId: this.dadosUsuario.informacoes.id,
        ...this.fields,
      };

      this.$store.dispatch('startLoader');
      this.saveBanner(request)
        .then((response) => {
          const { id } = response.data.data || {};
          this.fields.id = id;
          this.makeToast('Sucesso', 'Banner adicionado com sucesso');
          this.$router.push({ name: 'profissional-website-banner' });
        })
        .catch((error) => {
          this.handleErrorMessages(error.response.data.message);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    addImage() {
      if (!this.imageSelected) return;

      this.requiredFields.image = '';

      const formData = new FormData();
      formData.append('file', this.imageSelected);
      formData.append('validImg', 'validImg');

      this.$store.dispatch('startLoader');

      this.sendUploadFiles(formData)
        .then((response) => {
          if (response.data.error && response.data.error === true) {
            this.makeToast('Opss!', response.data.message, 'danger');
          } else {
            this.fields.image = (response.data.data || '').replace('/', '');
          }
        })
        .catch(() => {
          this.fields.image = '';

          this.makeToast('Oops!', 'Não foi possível inserir sua imagem, tente novamente!', 'danger');
        })
        .finally(() => {
          this.imageSelected = null;
          this.$store.dispatch('endLoader');
        });
    },
    removeImage() {
      if (!this.fields.image) return;

      const fileName = this.fields.image;
      this.fields.image = '';

      this.deleteFile(fileName).then().catch().finally();
    },
    handleErrorMessages(errorMessages) {
      if (!errorMessages) return;

      Object.keys(errorMessages).forEach((key) => {
        this.$set(this.requiredFields, key, 'Campo obrigatório');
      });
    },
  },
};
</script>
